"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@uirouter/angular");
const toggle_feature_flags_component_1 = require("./toggleFeatureFlags/toggle-feature-flags.component");
exports.states = [
    {
        name: "toggleFeatureFlags",
        url: "/customer-care/toggleFeatureFlags",
        component: toggle_feature_flags_component_1.ToggleFeatureFlagsComponent,
    }
];
